import { ref, computed, onMounted, onBeforeUnmount } from '@vue/composition-api';
import { Brand, Theme } from './Theme.js';

function useTheme(fallbackTheme, fallbackBrand) {
    var _a, _b, _c, _d, _e, _f;
    if (fallbackTheme === void 0) { fallbackTheme = Theme.Light; }
    if (fallbackBrand === void 0) { fallbackBrand = Brand.Sports; }
    var initialTheme = (_c = (_b = (_a = document.querySelector('html')) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b['theme']) !== null && _c !== void 0 ? _c : fallbackTheme;
    var initialBrand = (_f = (_e = (_d = document.querySelector('html')) === null || _d === void 0 ? void 0 : _d.dataset) === null || _e === void 0 ? void 0 : _e['brand']) !== null && _f !== void 0 ? _f : fallbackBrand;
    var theme = ref(initialTheme);
    var brand = ref(initialBrand);
    var observer;
    var themeSuffix = computed(function () {
        switch (brand.value) {
            case Brand.Sports:
                return "superbet-".concat(theme.value);
            case Brand.Gaming:
                return "superbet-gaming-".concat(theme.value);
            case Brand.NapoleonSports:
                return "napoleon-".concat(theme.value);
            case Brand.NapoleonGaming:
                return "napoleon-gaming-".concat(theme.value);
            default:
                return "".concat(brand.value, "-").concat(theme.value);
        }
    });
    onMounted(function () {
        var _a, _b, _c, _d;
        var htmlElement = document.querySelector('html');
        if (!htmlElement) {
            return;
        }
        theme.value = (_b = (_a = htmlElement.dataset) === null || _a === void 0 ? void 0 : _a['theme']) !== null && _b !== void 0 ? _b : fallbackTheme;
        brand.value = (_d = (_c = htmlElement.dataset) === null || _c === void 0 ? void 0 : _c['brand']) !== null && _d !== void 0 ? _d : fallbackBrand;
        observer = new MutationObserver(function (mutationList) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            theme.value = (_d = (_c = (_b = (_a = mutationList[0]) === null || _a === void 0 ? void 0 : _a.target) === null || _b === void 0 ? void 0 : _b.dataset) === null || _c === void 0 ? void 0 : _c['theme']) !== null && _d !== void 0 ? _d : fallbackTheme;
            brand.value = (_h = (_g = (_f = (_e = mutationList[0]) === null || _e === void 0 ? void 0 : _e.target) === null || _f === void 0 ? void 0 : _f.dataset) === null || _g === void 0 ? void 0 : _g['brand']) !== null && _h !== void 0 ? _h : fallbackBrand;
        });
        observer.observe(htmlElement, {
            attributes: true,
            attributeFilter: ['data-theme', 'data-brand'],
        });
    });
    onBeforeUnmount(function () {
        observer === null || observer === void 0 ? void 0 : observer.disconnect();
    });
    return {
        brand: brand,
        theme: theme,
        themeSuffix: themeSuffix,
    };
}

export { useTheme };
